import { render, staticRenderFns } from "./RRFL.vue?vue&type=template&id=673d32ad&scoped=true&"
import script from "./RRFL.vue?vue&type=script&lang=js&"
export * from "./RRFL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d32ad",
  null
  
)

export default component.exports